import React, {useEffect} from 'react';
import {courseSteps, flowOptions, groupRegistrationCourseSteps, initFlow} from "../../flowManager/FlowOptions";
import {useDispatch, useSelector} from "react-redux";
import {setTargetName, updateFlags, updateStepper} from "@arboxappv4/shared/src/redux/stepperSlice";
import {stepOptions} from "../../flowManager/StepOptions";

const useFlow = (props) => {
    const { flowSelection, initProps, formikRefCurrent } = props;
    const flags = useSelector(state => state.stepper.flags)
    const flowName = useSelector(state => state.stepper.flowName)
    const steps = useSelector(state => state.stepper.steps)
    const flowRes = useSelector(state => state.stepper.flowRes)
    const currStep = useSelector(state => state.stepper.currStep)
    const user = useSelector(state => state.user.data)
    const loggedIn = useSelector(state => state.auth.loggedIn)
    const box = useSelector(state => state.site.box)
    const dispatch = useDispatch()

    useEffect(() => {
        const flow = initFlow({flowName: flowSelection, initProps})
        setTimeout(() => dispatch(updateStepper(flow)), 10) // we need this otherwise, initial values useeffect is called twice and remove previous values
    }, [flowSelection]);

    useEffect(() => {
        if(initProps?.target) {
            dispatch(setTargetName(initProps.target.nameForTab))
        } else {
            dispatch(setTargetName(null))
        }
    }, [initProps]);

    useEffect(() => {
        if(flags.continueWithoutMembership && (flowName === flowOptions.REGISTER)) {
            const flow = initFlow({flowName: flowOptions.REGISTER_WITHOUT_MEMBERSHIP, initProps})
            dispatch(updateStepper(flow))
        }
    }, [flags.continueWithoutMembership]);

    useEffect(() => {
        if(flowName === flowOptions.REGISTER_WITHOUT_MEMBERSHIP && flags.continueWithoutMembership) {
            dispatch(updateFlags({continueWithoutMembership: false}))
        }
    }, [flowName]);

    useEffect(() => {
        if(![flowOptions.REGISTER, flowOptions.WAIVER].includes(flowName) && currStep !== stepOptions.SUCCESS && steps && currStep !== steps[0]) {
            if((user && loggedIn && !flags.loggedIn) || (!user && !loggedIn && flags.loggedIn)) {
                window.location.reload()
            }
        }
    }, [user, loggedIn]);

    useEffect(() => {
        // if user is not logged in, the only option for him to book is by pay for slot, so the steps are static.
        // if user is logged in, payment step will depend on the users membership choice (membership user or pay for slot).
        if([flowOptions.GROUP_SESSION, flowOptions.DIRECT_GROUP_SESSION, flowOptions.STAFF_APPOINTMENT, flowOptions.SPACE_APPOINTMENT, flowOptions.DIRECT_STAFF_APPOINTMENT, flowOptions.DIRECT_SPACE_APPOINTMENT].includes(flowName) && typeof flags.payForSlot === 'boolean' && loggedIn) {
            let newSteps
            if(flags.payForSlot) {
                if(!steps.includes(stepOptions.PAYMENT)) {
                    newSteps = [...steps, stepOptions.PAYMENT]
                }
            } else {
                newSteps = steps.filter(step => step !== stepOptions.PAYMENT)
            }
            dispatch(updateStepper({steps: newSteps, flags: {...flags, stepsUpdated: true}}))
        }
    }, [flags.payForSlot]);

    useEffect(() => {
        if([flowOptions.GROUP_SESSION, flowOptions.DIRECT_GROUP_SESSION].includes(flowName) && flowRes?.showSuccessToast) {
            const flow = initFlow({flowName, initProps})
            dispatch(updateStepper(flow))
        }
    }, [flowRes]);

};

export default useFlow;